module.exports = __webpack_public_path__ + "assets/img/swiper-1-3.b7087d5d.jpg";